var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArisMask1A(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 8.44819,
    height: 4.79068,
    viewBox: "0 0 8.44819 4.79068",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.71733 4.77273L0 0.0471212L5.74431 0L8.44818 4.79068L2.71733 4.77273Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArisMask1A);
export default __webpack_public_path__ + "static/media/aris-mask1a.5eb7f657c8706c81099f484821491ae7.svg";
export { ForwardRef as ReactComponent };